import {Exclude, Expose, Type} from "class-transformer";
import {AbstractApiModel} from "./abstract.api.model";
import {CityApiModel} from "./city.api-model";
import {CountryApiModel} from "./country.api-model";

@Exclude()
export class PersonalInformationApiModel extends AbstractApiModel {
  @Expose() public firstName: string;
  @Expose() public lastName: string;
  @Expose() public phone: string;
  @Expose() public address: string;
  @Expose() public streetNr: string;
  @Expose() public houseNr: string;
  @Expose() public postcode: string;
  @Expose() public province: string;
  @Type(() => CityApiModel)
  @Expose() public city: CityApiModel|string;
  @Type(() => CountryApiModel)
  @Expose() public country: CountryApiModel|string;
}
